// extracted by mini-css-extract-plugin
export var drawerPaper = "_24-0";
export var itemImage = "_24-1";